import React from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageSwitcher.css';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  const currentLanguage = i18n.language;

  return (
    <div className="language-switcher">
      <button
        className={`lang-btn ${currentLanguage === 'fr' ? 'active' : ''}`}
        onClick={() => changeLanguage('fr')}
        title="Changer en français"
      >
        FR
      </button>
      <button
        className={`lang-btn ${currentLanguage === 'en' ? 'active' : ''}`}
        onClick={() => changeLanguage('en')}
        title="Switch to English"
      >
        EN
      </button>
    </div>
  );
};

export default LanguageSwitcher;